import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import DstButton from "../../../components/DstButton/DstButton";
import DstFooter from "../../../components/DstFooter/DstFooter";
import DstNavbar from "../../../components/DstNavbar/DstNavbar";
import DstSlider from "../../../components/DstSlider/DstSlider";
import HeaderContent from "../../../components/HeaderContent/HeaderContent";
import HubspotForm from "../../../components/HubspotForm/HubspotForm";
import InfoCard from "../../../components/InfoCard/InfoCard";
import Popup from "../../../components/Popup/Popup";
import PreFooterOmnes from "../../../components/PreFooterOmnes/PreFooterOmnes";
import Title from "../../../components/DstTitle/DstTitle";
import { ContactSection } from "../Formation.component";

const slides = [
  {
    imageUrl: "/assets/images/home/btp-tertiaire.png",
    text: "Technicien CVC",
    link: "/formation-technicien-cvc",
  },
  {
    imageUrl: "/assets/images/home/btp-tertiaire.png",
    text: "Technicien de Maintenance Multi-technique",
    link: "/formation-technicien-maintenance-multi-technique",
  },
  {
    imageUrl: "/assets/images/home/btp-tertiaire.png",
    text: "Technicien de Maintenance Industrielle",
    link: "/formation-technicien-maintenance-industrielle",
  },
  {
    imageUrl: "/assets/images/home/btp-tertiaire.png",
    text: "Technicien de Maintenance Industrielle Automatisme",
    link: "/formation-technicien-maintenance-industrielle-automatisme",
  },
];

const FormationsBtpTertiaire = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  return (
    <React.Fragment>
      <DstNavbar />
      <HeaderContent
        alt="BTP-Tertiaire"
        image="/assets/images/home/btp-tertiaire.png"
        title={
          <h1>
            Formez vos futurs collaborateurs au secteur{" "}
            <span className="blue-font">BTP-Tertiaire</span>
          </h1>
        }
        content={
          <div className="mt-3">
            <p>
              Le secteur BTP-Tertiaire rassemble les métiers indispensables à la
              performance énergétique, à la maintenance multi-technique et au
              pilotage intelligent des bâtiments.
            </p>
            <p>
              Trouvez vos futurs collaborateurs dans ce domaine grâce à Liora !
            </p>
          </div>
        }
        dstButton={{
          value: "J’envoie mon cv",
          clickFunction: () => setShowModal(true),
          variant: "secondary",
          disableAnimation: true,
        }}
      />
      <Container>
        <Title
          text="Formations"
          tag="h2"
          className="h3"
          color="#2424ff"
          underlineColor="#9D9FAB"
          underlineWidth={60}
        />
        <h1>
          Découvrez nos{" "}
          <span className="blue-font">formations en BTP-Tertiaire</span>
        </h1>
        <DstSlider slides={slides} height="150px" />
        <div className="d-flex flex-column align-items-center">
          <DstButton
            value="PRENDRE RDV"
            btnClass="l-black mb-5"
            disableAnimation
            variant="secondary"
            clickFunction={() => navigate("/rdv")}
          />
        </div>
      </Container>
      <div className="dark-background white-font py-3 py-md-5">
        <Container className="my-3 my-md-5">
          <Title
            text="Recrutement"
            tag="div"
            className="h3"
            color="#20FFA4"
            underlineColor="#9D9FAB"
            textUppercase
          />
          <h3 className="h2 mb-3 mb-md-5">
            Comment s’organise le{" "}
            <span className="green-font">recrutement</span>
          </h3>
          <Row>
            <InfoCard
              title="Définition du besoin"
              text="Liora identifie les besoins spécifiques des entreprises et détermine les profils à sourcer, ainsi que la formation adaptée à ces profils."
              imageSrc="/assets/images/icon/write.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Sourcing"
              text="En accord avec les critères de sélection, Liora identifie et sélectionne les profils les plus proches des besoins spécifiques de l’entreprise."
              imageSrc="/assets/images/icon/light.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Formation"
              text="Une fois les profils sélectionnés et validés par l’entreprise, ils entament une formation intensive adaptée au métier visé."
              imageSrc="/assets/images/icon/book.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Validation et embauche"
              text="La validation de la formation et de l’embauche est soumise à une soutenance à laquelle les équipes de l’entreprise sont invitées."
              imageSrc="/assets/images/icon/work.svg"
              borderColor="#F7F7F7"
            />
          </Row>
          <div className="text-center">
            <DstButton
              value="télécharger la brochure"
              btnClass="m-bold"
              clickFunction={() => setShowModal(true)}
            />
          </div>
        </Container>
      </div>
      <Container className="mt-3 mt-md-5">
        <ContactSection
          portalId="19831339"
          formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
        />
      </Container>
      <PreFooterOmnes />
      <DstFooter />
      <Popup
        show={showModal}
        onClose={() => setShowModal(false)}
        modalTitle="Syllabus Secteur BTP-Tertiaire"
      >
        <HubspotForm
          portalId="19831339"
          formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
        />
      </Popup>
    </React.Fragment>
  );
};

export default FormationsBtpTertiaire;
